import ListAPI from '../../../api/lists';
import types from '../../mutation-types';

const latestRequest = { lists: 0, members: 0, item: 0 };
let membersListId = null;

export const actions = {
  async get({ commit }, { page = 1, ...params } = {}) {
    latestRequest.lists += 1;
    const requestId = latestRequest.lists;
    commit(types.SET_LISTS_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload, meta },
      } = await ListAPI.get(page, params);
      if (requestId !== latestRequest.lists) return false;
      commit(types.CLEAR_LISTS);
      commit(types.SET_LISTS, payload);
      commit(types.SET_LIST_META, meta);
      return true;
    } finally {
      if (requestId === latestRequest.lists) {
        commit(types.SET_LISTS_UI_FLAG, { isFetching: false });
      }
    }
  },

  async show({ commit, state }, id) {
    latestRequest.item += 1;
    const requestId = latestRequest.item;
    if (state.currentList && String(state.currentList.id) !== String(id)) {
      commit(types.SET_CURRENT_LIST, null);
      commit(types.CLEAR_LIST_MEMBERS);
      membersListId = null;
      latestRequest.members += 1;
      commit(types.SET_LISTS_UI_FLAG, { isFetchingMembers: false });
    }
    commit(types.SET_LISTS_UI_FLAG, { isFetchingItem: true });
    try {
      const {
        data: { payload },
      } = await ListAPI.show(id);
      if (requestId !== latestRequest.item) return null;
      commit(types.SET_CURRENT_LIST, payload);
      return payload;
    } finally {
      if (requestId === latestRequest.item) {
        commit(types.SET_LISTS_UI_FLAG, { isFetchingItem: false });
      }
    }
  },

  async create({ commit }, list) {
    commit(types.SET_LISTS_UI_FLAG, { isCreating: true });
    try {
      const {
        data: { payload },
      } = await ListAPI.create(list);
      return payload;
    } finally {
      commit(types.SET_LISTS_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { id, ...list }) {
    commit(types.SET_LISTS_UI_FLAG, { isUpdating: true });
    try {
      const {
        data: { payload },
      } = await ListAPI.update(id, list);
      return payload;
    } finally {
      commit(types.SET_LISTS_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, { id, deleteContacts = false }) {
    commit(types.SET_LISTS_UI_FLAG, { isDeleting: true });
    try {
      await ListAPI.delete(id, { deleteContacts });
    } finally {
      commit(types.SET_LISTS_UI_FLAG, { isDeleting: false });
    }
  },

  async duplicate({ commit }, { id, name } = {}) {
    commit(types.SET_LISTS_UI_FLAG, { isDuplicating: true });
    try {
      const {
        data: { payload },
      } = await ListAPI.duplicate(id, name);
      return payload;
    } finally {
      commit(types.SET_LISTS_UI_FLAG, { isDuplicating: false });
    }
  },

  async getMembers({ commit }, { listId, page = 1, ...params }) {
    latestRequest.members += 1;
    const requestId = latestRequest.members;
    if (listId !== membersListId) {
      membersListId = listId;
      commit(types.CLEAR_LIST_MEMBERS);
    }
    commit(types.SET_LISTS_UI_FLAG, { isFetchingMembers: true });
    try {
      const {
        data: { payload, meta },
      } = await ListAPI.getMembers(listId, page, params);
      if (requestId !== latestRequest.members) return false;
      commit(types.CLEAR_LIST_MEMBERS);
      commit(types.SET_LIST_MEMBERS, payload);
      commit(types.SET_LIST_MEMBER_META, meta);
      return true;
    } finally {
      if (requestId === latestRequest.members) {
        commit(types.SET_LISTS_UI_FLAG, { isFetchingMembers: false });
      }
    }
  },

  async addMember({ commit }, { listId, contactId }) {
    commit(types.SET_LISTS_UI_FLAG, { isAddingMember: true });
    try {
      const { data } = await ListAPI.addMember(listId, contactId);
      return data?.payload || data;
    } finally {
      commit(types.SET_LISTS_UI_FLAG, { isAddingMember: false });
    }
  },

  async removeMember({ commit }, { listId, listMemberId }) {
    commit(types.SET_LISTS_UI_FLAG, { isRemovingMember: true });
    try {
      await ListAPI.removeMember(listId, listMemberId);
    } finally {
      commit(types.SET_LISTS_UI_FLAG, { isRemovingMember: false });
    }
  },
};
